import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

interface ILoadingProps {
  cssContainer?: string;
  cssImagen?: string;
} 
export default function Loading({ cssContainer, cssImagen }:ILoadingProps) {
  return <div className={`mx-auto text-center ${cssContainer}`}>
    <img src={require("../assets/img/loading1TLC.gif")} alt="Cargando" className={`loading border border-2 rounded p-3 bg-light ${cssImagen}`} />
  </div>;
}
